import { ContactDepartment } from 'src/public/models/contactDepartment';
import React from 'react';

export const contactDepartments: ContactDepartment[] = [
  {
    title: 'Wsparcie sprzedażowe i oferta finansowa',
    contactPageTitle: 'Wsparcie sprzedażowe i oferta finansowa',
    excerpt: 'dla klientów i użytkowników platformy',
    description: (
      <>
        Chcesz spełnić swoje marzenie o nowym samochodzie, ale nie wiesz, która
        oferta finansowa jest dla Ciebie? Potrzebujesz pomocy przy wyborze auta?
        Skontaktuj się z&nbsp;nami.
      </>
    ),
    contact: {
      label: 'Car Platform Team',
      mail: 'wsparcie@carplatform.pl',
      phone: '+48 732 070 426',
    },
  },
  {
    title: 'Wsparcie firmowe',
    contactPageTitle: 'Wsparcie firmowe',
    excerpt: 'dla firm zainteresowanych dostępem dla pracowników ',
    description: (
      <>
        Jeśli chcesz, aby Twoi pracownicy otrzymali dostęp do naszej platformy,
        skontaktuj się z&nbsp;nami.
      </>
    ),
    contact: {
      mail: 'hello@carplatform.pl',
      phone: '+48 720 811 206',
    },
  },
];
